import React, { useState } from "react";
import "./gallery.css";

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const images = [];

  // 🎥 Videos
  const videos = [
    {
      src: `${process.env.PUBLIC_URL}/images/vid1.mp4`,
      caption: "🎬 ग्रामपंचायत सायकी – विकासाची व्हिडिओ झलक 1",
    },
    {
      src: `${process.env.PUBLIC_URL}/images/vid2.mp4`,
      caption: "🎬 ग्रामपंचायत सायकी – विकासाची व्हिडिओ झलक 2",
    },
    {
      src: `${process.env.PUBLIC_URL}/images/vid3.mp4`,
      caption: "🎬 ग्रामपंचायत सायकी – विकासाची व्हिडिओ झलक 3",
    },
    {
      src: `${process.env.PUBLIC_URL}/images/vid4.mp4`,
      caption: "🎬 ग्रामपंचायत सायकी – विकासाची व्हिडिओ झलक 3",
    },
  ];

  // ❌ Images to remove
  const removeList = [
    78, 58, 88, 77, 140, 79, 80, 83, 117, 118, 121, 128, 142, 143, 144, 141,
    113, 111, 112, 90, 92, 93, 99, 89, 91, 97, 98, 106, 107, 71, 70, 61, 64,
    65, 16, 22, 53, 6, 60, 63, 26, 132, 133, 105, 102, 85, 86, 87,
  ];

  // ✅ Build image list
  for (let i = 1; i <= 204; i++) {
    if (!removeList.includes(i)) {
      images.push({
        src: `${process.env.PUBLIC_URL}/images/photo${i}.jpeg`,
        number: i,
      });
    }
  }
       
  return (
    <div className="gallery-container">
      <h2 className="gallery-title">📸 गावाचा विकास – छायाचित्रांतून</h2>

      {/* 🎥 Video Section */}
      <div className="featured-video">
        {videos.map((video, index) => (
          <div key={index} className="video-box">
            <video
              src={video.src}
              controls
              className="featured-video-player"
            />
            <div className="featured-video-caption">{video.caption}</div>
          </div>
        ))}
      </div>

      {/* 🖼️ Image Gallery */}
      <div className="gallery-grid">
        {images.map((img) => (
          <div
            className="gallery-card"
            key={img.number}
            onClick={() => setSelectedImage(img)}
          >
            <img
              src={img.src}
              alt={`Photo ${img.number}`}
              className="gallery-img"
              onError={(e) => (e.target.style.display = "none")}
            />
            <div className="gallery-caption">
              छायाचित्र क्रमांक {img.number}
            </div>
          </div>
        ))}
      </div>

      {/* 🔍 Image Popup */}
      {selectedImage && (
        <div className="image-popup" onClick={() => setSelectedImage(null)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <span className="popup-close" onClick={() => setSelectedImage(null)}>
              ✖
            </span>
            <img
              src={selectedImage.src}
              alt={`Photo ${selectedImage.number}`}
            />
            <p className="popup-caption">
              छायाचित्र क्रमांक {selectedImage.number}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;